import { getLogger } from '@signalwire/core';
import { RTCPeerConnectionManager } from './RTCPeerConnectionManager';
class ConnectionPoolManagerSingleton {
    constructor() {
        this.logger = getLogger();
    }
    async initializePool(iceServers, options = {}) {
        var _a, _b;
        if (this.manager) {
            this.logger.warn('Connection pool already initialized');
            return;
        }
        this.logger.info('Initializing connection pool');
        const rtcConfig = {
            iceServers,
            iceCandidatePoolSize: (_a = options.iceCandidatePoolSize) !== null && _a !== void 0 ? _a : 10,
        };
        this.manager = new RTCPeerConnectionManager(rtcConfig, (_b = options.poolSize) !== null && _b !== void 0 ? _b : 2);
        await this.manager.initializePool();
    }
    getConnection() {
        if (!this.manager) {
            this.logger.warn('Connection pool not initialized');
            return null;
        }
        return this.manager.getConnection();
    }
    cleanup() {
        if (this.manager) {
            this.logger.info('Cleaning up connection pool');
            this.manager.cleanup();
            this.manager = undefined;
        }
    }
    get isInitialized() {
        return !!this.manager;
    }
}
// Export singleton instance
export const connectionPoolManager = new ConnectionPoolManagerSingleton();
//# sourceMappingURL=connectionPoolManager.js.map